// Prompt Builder's mount, injected by vite.config.ts (PB_BASE). The
// worker-side twin is PB_BASE_PATH in wrangler.jsonc.
export const PB_BASE_PATH: string = import.meta.env.VITE_PB_BASE_PATH;

export function withBase(path: string): string {
  return PB_BASE_PATH + path;
}
